import React from "react";
import { ArrowRight, CheckCircle, MessageCircle } from "lucide-react";
import { heroData } from "../data/mock";

const HeroSection = ({ onOpenForm }) => {
  return (
    <section id="home" className="relative pt-24 pb-20 lg:pt-32 lg:pb-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#f8fafc] via-white to-[#e0f2fe] opacity-60"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#1e3a8a]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl"></div>

      <div className="container-custom px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in-up">
            <div className="inline-flex items-center space-x-2 bg-[#1e3a8a]/10 px-4 py-2 rounded-full">
              <CheckCircle className="w-5 h-5 text-[#1e3a8a]" />
              <span className="text-sm font-semibold text-[#1e3a8a]">
                USPTO Filing Experts | 15,000+ Trademarks Filed
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              {heroData.description}
            </p>

            <p className="text-base text-gray-700 leading-relaxed">
              Our comprehensive trademark registration services are designed to protect your business identity 
              at every step. From conducting thorough trademark searches to filing with the USPTO and monitoring 
              your trademark status, we ensure your brand receives the maximum legal protection it deserves. 
              With over a decade of experience and thousands of successful registrations, we're the trusted 
              choice for businesses nationwide.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={onOpenForm}
                className="btn-primary flex items-center justify-center space-x-2 text-lg"
              >
                <span>Register My Trademark</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <button className="btn-secondary flex items-center justify-center space-x-2 text-lg">
                <MessageCircle className="w-5 h-5" />
                <span>Chat Now</span>
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              {heroData.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-[#1e3a8a] mb-1">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={heroData.image}
                alt="Professional Legal Services"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a8a]/20 to-transparent"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border-l-4 border-[#d4af37]">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                  <CheckCircle className="w-6 h-6 text-[#d4af37]" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#1e3a8a]">98%</div>
                  <div className="text-sm text-gray-600">Success Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-20 pt-12 border-t border-gray-200">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
            <div className="text-center">
              <div className="text-[#1e3a8a] font-bold text-lg mb-1">USPTO Registered</div>
              <div className="text-sm text-gray-600">Licensed Attorneys</div>
            </div>
            <div className="text-center">
              <div className="text-[#1e3a8a] font-bold text-lg mb-1">Fast Processing</div>
              <div className="text-sm text-gray-600">Quick Turnaround</div>
            </div>
            <div className="text-center">
              <div className="text-[#1e3a8a] font-bold text-lg mb-1">100% Satisfaction</div>
              <div className="text-sm text-gray-600">Money-Back Guarantee</div>
            </div>
            <div className="text-center">
              <div className="text-[#1e3a8a] font-bold text-lg mb-1">24/7 Support</div>
              <div className="text-sm text-gray-600">Dedicated Team</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
